import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// import { GRA_PATH, PATH } from "../../../utils/Constants";
import { PATH } from '../../../utils/Constants';
import whiteLogo from '../../../utils/images/bloomifai_logo.png';
import Badge from '@mui/material/Badge';
import { getUnreadCounts } from '../../action/Admin/CommonAction';
import { LanguageProvider, useLanguage } from '../../../utils/common/LanguageContext';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */

// HOC to inject language context into class component
const withLanguage = (Component) => {
    return (props) => {
        const { t } = useLanguage();
        return <Component {...props} t={t} />;
    };
};

class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            unReadMessageCount: 0,
            apiUnreadCount: 0,
        };
    }

    //componentDidMount
    componentDidMount() {
        this.getUnreadCounts();
    }

    //componentDidUpdate
    componentDidUpdate(prevProps) {
        if (prevProps.socketUnreadCount !== this.props.socketUnreadCount) {
            this.setState({
                unReadMessageCount: this.props.socketUnreadCount,
            });
        }
    }

    //getUnreadCounts
    getUnreadCounts = () => {
        this.props.getUnreadCounts((result) => {
            if (result && result.response) {
                const apiUnreadCount = result.response.unReadMessageCount;
                this.setState({
                    apiUnreadCount,
                    unReadMessageCount: apiUnreadCount,
                });
            }
        });
    };

    /**
     * Render page
     */
    render() {
        const { unReadMessageCount } = this.state;
        return (
            <div>
                <aside
                    className={`w-64 bg-UINavigation transition-all flex flex-col gap-8 xl:relative fixed h-full xl:left-0 z-20 ${
                        this.props.mobileNav ? 'left-0' : '-left-96'
                    }`}
                >
                    <div className="relative flex justify-center p-4">
                        <img src={whiteLogo} alt="VirtuOwl" className="relative h-16 w-26" />{' '}
                        <button
                            className="absolute block -right-8 xl:hidden"
                            onClick={() => {
                                this.props.onClickMobileNav(false);
                            }}
                        >
                            <i className="text-xl text-white far fa-times"></i>
                        </button>
                    </div>
                    {!this.props.changeScreen && (
                        <nav className="flex flex-col">
                            <Link
                                className={
                                    this.props.active === PATH.IM_PATIENT.DASHBOARD
                                        ? 'mdl-navigation__link items-center text-white p-4 mx-auto w-10/12 font-normal flex gap-4 bg-light bg-opacity-10 rounded-lg'
                                        : 'items-center text-white p-4 font-normal flex gap-4 mx-auto w-10/12'
                                }
                                to={`${PATH.IM_PATIENT.DASHBOARD}/${this.props.match.params.userId}`}
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M8 12V10"
                                        stroke="#F6F8FB"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M6.71334 1.87998L2.09334 5.57998C1.57334 5.99331 1.24 6.86665 1.35334 7.51998L2.24 12.8266C2.4 13.7733 3.30667 14.54 4.26667 14.54H11.7333C12.6867 14.54 13.6 13.7666 13.76 12.8266L14.6467 7.51998C14.7533 6.86665 14.42 5.99331 13.9067 5.57998L9.28667 1.88665C8.57334 1.31331 7.42 1.31331 6.71334 1.87998Z"
                                        stroke="#F6F8FB"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>{' '}
                                {this.props.t('home')}
                            </Link>
                            <Link
                                className={
                                    this.props.active === PATH.IM_PATIENT.APPOINTMENT
                                        ? 'mdl-navigation__link items-center text-white mx-auto w-10/12 p-4 font-normal flex gap-4 bg-light bg-opacity-10 rounded-lg'
                                        : 'items-center text-white p-4 font-normal flex gap-4 mx-auto w-10/12'
                                }
                                to={`${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}`}
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M5.33334 1.33325V3.33325"
                                        stroke="white"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M10.6667 1.33325V3.33325"
                                        stroke="white"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M2.33334 6.06006H13.6667"
                                        stroke="white"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M14 5.66659V11.3333C14 13.3333 13 14.6666 10.6667 14.6666H5.33333C3 14.6666 2 13.3333 2 11.3333V5.66659C2 3.66659 3 2.33325 5.33333 2.33325H10.6667C13 2.33325 14 3.66659 14 5.66659Z"
                                        stroke="white"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M10.4631 9.13338H10.4691"
                                        stroke="white"
                                        strokeWidth="1.33333"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M10.4631 11.1334H10.4691"
                                        stroke="white"
                                        strokeWidth="1.33333"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M7.997 9.13338H8.00299"
                                        stroke="white"
                                        strokeWidth="1.33333"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M7.997 11.1334H8.00299"
                                        stroke="white"
                                        strokeWidth="1.33333"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M5.52953 9.13338H5.53552"
                                        stroke="white"
                                        strokeWidth="1.33333"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M5.52953 11.1334H5.53552"
                                        stroke="white"
                                        strokeWidth="1.33333"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>{' '}
                                {this.props.t('sessions')}
                            </Link>
                            <Link
                                className={
                                    this.props.active === PATH.IM_PATIENT.MESSAGES
                                        ? 'mdl-navigation__link items-center text-white p-4 font-normal mx-auto w-10/12 flex gap-4 bg-light bg-opacity-10 rounded-lg'
                                        : 'items-center text-white p-4 font-normal flex gap-4 mx-auto w-10/12'
                                }
                                to={`${PATH.IM_PATIENT.MESSAGES}/${this.props.match?.params.userId}`}
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M11.3333 13.6666H4.66668C2.66668 13.6666 1.33334 12.6666 1.33334 10.3333V5.66659C1.33334 3.33325 2.66668 2.33325 4.66668 2.33325H11.3333C13.3333 2.33325 14.6667 3.33325 14.6667 5.66659V10.3333C14.6667 12.6666 13.3333 13.6666 11.3333 13.6666Z"
                                        stroke="white"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M11.3333 6L9.24665 7.66667C8.55999 8.21333 7.43332 8.21333 6.74665 7.66667L4.66666 6"
                                        stroke="white"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>{' '}
                                {this.props.t('messages')}
                                {this.props.active !== PATH.IM_PATIENT.MESSAGES && (
                                    <Badge
                                        className="absolute right-[56%] bottom-3"
                                        badgeContent={unReadMessageCount}
                                        sx={{
                                            '& .MuiBadge-badge': {
                                                backgroundColor: '#43a6b9',
                                                color: 'white',
                                            },
                                        }}
                                    />
                                )}
                            </Link>
                        </nav>
                    )}
                </aside>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    socketUnreadCount: state.UnreadReducerCount.unReadMessageCount,
});

const mapDispatchToProps = (dispatch) => {
    return {
        getUnreadCounts: (callback) => {
            dispatch(getUnreadCounts(callback));
        },
    };
};

const ConnectedNavigation = connect(mapStateToProps, mapDispatchToProps)(withLanguage(Navigation));

export default (props) => (
    <LanguageProvider>
        <ConnectedNavigation {...props} />
    </LanguageProvider>
);
